import { render, staticRenderFns } from "./index.vue?vue&type=template&id=847ea3e6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\008-QLK_FE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('847ea3e6')) {
      api.createRecord('847ea3e6', component.options)
    } else {
      api.reload('847ea3e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=847ea3e6&", function () {
      api.rerender('847ea3e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rma-number/index.vue"
export default component.exports